export const isShorthandColorPossible = (color: string) => {
    let clr = color;

    clr = clr.replace(/^#/, '');

    return clr[0] === clr[1] && clr[2] === clr[3] && clr[4] === clr[5];
};
